import { makeStyles } from "tss-react/mui";

import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import type { Row } from "@tanstack/react-table";

import { OtaFile } from "../../types";

const useStyles = makeStyles()((theme) => ({
    tagsCell: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(0.5),
    },
}));

type VersionTableTagsCellProps = {
    row: Row<OtaFile>;
};

export const VersionTableTagsCell = ({ row }: VersionTableTagsCellProps) => {
    const { classes } = useStyles();
    const tags = Object.entries(row.original.annotation?.metadata?.user ?? {}).map(([key, value]): API.Tag => ({
        key,
        value,
        type: value ? "scoped" : "simple",
    }));

    return (
        <MinimalTableCell>
            <div className={classes.tagsCell}>
                {tags.map((tag) => (
                    <Tag key={tag.key} item={tag} />
                ))}
            </div>
        </MinimalTableCell>
    );
};
